var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shift-attendance',
  created () {
    this.printDate = new Date()
  },
  data () {
    return {
      canValidate: true,
      printDate: null
    }
  },
  computed: {
    validation: function () {
      var v = {
        print_date: !!this.printDate,
        not_input: !!this.printDate
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    printDateFormat: function() {
      return this.printDate.getFullYear() + '-' + ("0" + (this.printDate.getMonth() + 1)).slice(-2) + '-' + ("0" + this.printDate.getDate()).slice(-2)
    }
  },
  components: {
    AppHeader
  },
  methods: {
    printAttendance: function () {
      var data = {
        'shop_id': window.localStorage.getItem('shop_id'),
        'target_date': this.printDateFormat
      }
      this.$store.dispatch('PRINT_ATTENDANCE', {data: data, callback: this.onGetPdf } )
    },
    onGetPdf: function(data) {
      var link = document.getElementById('print_download_link')
      link.setAttribute('download', data.url)
      link.href = data.url
      link.target = "_blank"
      link.click()
      // ファイル削除
      this.$store.dispatch('PRINT_ATTENDANCE_REMOVE_PDF', {data:{download_id: data.download_id}, callback: (data) => {}})
    },
    onClickCancel: function () {
      this.$router.push({ path: '/shift_manage'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-attendance.js